import { render, staticRenderFns } from "./ProductNumberOfShop.vue?vue&type=template&id=dfcdb408&scoped=true&"
import script from "./ProductNumberOfShop.vue?vue&type=script&lang=js&"
export * from "./ProductNumberOfShop.vue?vue&type=script&lang=js&"
import style0 from "./ProductNumberOfShop.vue?vue&type=style&index=0&id=dfcdb408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcdb408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dfcdb408', component.options)
    } else {
      api.reload('dfcdb408', component.options)
    }
    module.hot.accept("./ProductNumberOfShop.vue?vue&type=template&id=dfcdb408&scoped=true&", function () {
      api.rerender('dfcdb408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shop/ProductNumberOfShop.vue"
export default component.exports